import {createTheme, ThemeProvider} from "@mui/material/styles";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import BottomNavigation from '@mui/material/BottomNavigation';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SmsIcon from '@mui/icons-material/Sms';
import SpaIcon from '@mui/icons-material/Spa';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import { Stack, Box } from '@mui/material';
import getLPTheme from '../getLPTheme';

const App = ({withNavigation, children, top}) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const lightTheme = createTheme(getLPTheme('light'));

    return (
        // renstart
        <ThemeProvider theme={lightTheme}>
            <Stack
                className='App'
                sx={{
                    justifyContent: 'space-between',
                }}
            >
                <Box>
                    { top }
                </Box>
                <Box sx={{overflowY: 'auto', height: '100%'}}>
                    { children }
                </Box>
                <Box>
                    {
                        withNavigation ?
                            <BottomNavigation
                                showLabels
                                value={''}
                                sx={{
                                    width: '100%',
                                    m: 0,
                                    p: 0,
                                    display: { xs: 'flex', sm: 'none'},
                                    borderTop: '1px solid gray',
                                    zIndex: 1299 // greate than swipable drawer 1300
                                }}
                                onChange={(event, newValue) => {
                                    if (newValue == 'account') {
                                        navigate('/account');
                                    } else if (newValue == 'services') {
                                        navigate('/');
                                    } else if (newValue == 'chats') {
                                        navigate('/chats')
                                    }
                                    //                 navigate('/login');
                                    //             } else if (/\/users\/\d+\/enable/.test(pathname)) {
                                }}
                            >
                                <BottomNavigationAction
                                    sx={{
                                        color: pathname == '/' ? '#A95C68' : null,
                                        '&.Mui-selected': {
                                            color: 'crimson',
                                        }
                                    }}
                                    label="Сервисы"
                                    value={'services'}
                                    icon={<CalendarViewDayIcon />} />
                                <BottomNavigationAction
                                    sx={{
                                        color: pathname == '/chats' ? '#A95C68' : null,
                                        '&.Mui-selected': {
                                            color: 'crimson',
                                        }
                                    }}
                                    label="Чаты"
                                    value={'chats'}
                                    icon={<SmsIcon />} />
                                <BottomNavigationAction
                                    sx={{
                                        color: pathname == '/account' ? '#A95C68' : null,
                                        '&.Mui-selected': {
                                            color: 'crimson',
                                        }
                                    }}
                                    label="Aккаунт"
                                    value={'account'}
                                    icon={<AccountCircleIcon />} />
                            </BottomNavigation> : null
                    }
                </Box>
            </Stack>
            {/*<div className="App">*/}
            {/*    { children }*/}
            {/*    {*/}
            {/*       withNavigation ?*/}
            {/*           <BottomNavigation*/}
            {/*               showLabels*/}
            {/*               value={''}*/}
            {/*               sx={{*/}
            {/*                   width: '100%',*/}
            {/*                   position: 'fixed',*/}
            {/*                   bottom: 0,*/}
            {/*                   m: 0,*/}
            {/*                   p: 0,*/}
            {/*                   display: { xs: 'flex', sm: 'none'},*/}
            {/*                   borderTop: '1px solid gray',*/}
            {/*                   zIndex: 1299 // greate than swipable drawer 1300*/}
            {/*               }}*/}
            {/*               onChange={(event, newValue) => {*/}
            {/*                   if (newValue == 'account') {*/}
            {/*                       navigate('/account');*/}
            {/*                   } else if (newValue == 'services') {*/}
            {/*                       navigate('/');*/}
            {/*                   } else if (newValue == 'chats') {*/}
            {/*                       navigate('/chats')*/}
            {/*                   }*/}
            {/*                   //                 navigate('/login');*/}
            {/*                   //             } else if (/\/users\/\d+\/enable/.test(pathname)) {*/}
            {/*               }}*/}
            {/*           >*/}
            {/*               <BottomNavigationAction*/}
            {/*                   sx={{*/}
            {/*                       color: pathname == '/' ? '#A95C68' : null,*/}
            {/*                       '&.Mui-selected': {*/}
            {/*                           color: 'crimson',*/}
            {/*                       }*/}
            {/*                   }}*/}
            {/*                   label="Сервисы"*/}
            {/*                   value={'services'}*/}
            {/*                   icon={<CalendarViewDayIcon />} />*/}
            {/*               <BottomNavigationAction*/}
            {/*                   sx={{*/}
            {/*                       color: pathname == '/chats' ? '#A95C68' : null,*/}
            {/*                       '&.Mui-selected': {*/}
            {/*                           color: 'crimson',*/}
            {/*                       }*/}
            {/*                   }}*/}
            {/*                   label="Чаты"*/}
            {/*                   value={'chats'}*/}
            {/*                   icon={<SmsIcon />} />*/}
            {/*               <BottomNavigationAction*/}
            {/*                   sx={{*/}
            {/*                       color: pathname == '/account' ? '#A95C68' : null,*/}
            {/*                       '&.Mui-selected': {*/}
            {/*                           color: 'crimson',*/}
            {/*                       }*/}
            {/*                   }}*/}
            {/*                   label="Aккаунт"*/}
            {/*                   value={'account'}*/}
            {/*                   icon={<AccountCircleIcon />} />*/}
            {/*           </BottomNavigation> : null*/}
            {/*    }*/}
            {/*</div>*/}
        </ThemeProvider>
    );
}

export default App;
